module.exports = __webpack_public_path__ + "img/logotipo-derosso-site-branco.52fd0432.png";